<template>
  <q-card-section class="schema-header bg-primary">
    <div class="row items-center">
      <!-- Header Title and Subtitle -->
      <div class="col">
        <div class="row items-center">
          <q-avatar
            color="white"
            text-color="primary"
            size="40px"
            class="q-mr-md"
          >
            <q-icon name="schema" size="24px" />
          </q-avatar>
          <div>
            <div class="text-h5 text-weight-bold text-white">
              <slot name="title">BRICK Schema Management</slot>
            </div>
            <div class="text-body2 text-blue-2">
              <slot name="subtitle" />
            </div>
            <!-- Quote Context Indicator -->
            <div v-if="quoteContext" class="q-mt-xs">
              <q-chip
                dense
                color="amber"
                text-color="dark"
                icon="request_quote"
                class="q-mr-xs"
              >
                Quote Context: {{ quoteContext.quote_number }}
                <span v-if="quoteContext.option_name" class="q-ml-xs">({{ quoteContext.option_name }})</span>
              </q-chip>
              <q-chip
                v-if="quoteContext.is_locked"
                dense
                color="red"
                text-color="white"
                icon="lock"
              >
                LOCKED
              </q-chip>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="col-auto">
        <q-btn-group flat>
          <!-- Refresh Button -->
          <q-btn
            flat
            round
            icon="refresh"
            size="md"
            :loading="loading"
            text-color="white"
            class="q-mr-sm"
            @click="emit('refresh')"
          >
            <q-tooltip>Refresh Data</q-tooltip>
          </q-btn>

          <!-- Export Button -->
          <q-btn
            v-if="showExport"
            flat
            round
            icon="download"
            size="md"
            text-color="white"
            class="q-mr-sm"
            @click="emit('export')"
          >
            <q-tooltip>Export Data</q-tooltip>
          </q-btn>

          <!-- Import Button -->
          <q-btn
            v-if="showImport"
            flat
            round
            icon="upload"
            size="md"
            text-color="white"
            class="q-mr-sm"
            @click="emit('import')"
          >
            <q-tooltip>Import Data</q-tooltip>
          </q-btn>

          <!-- Changes Indicator -->
          <q-chip
            v-if="hasChanges"
            dense
            color="amber"
            text-color="dark"
            icon="edit"
            class="q-mr-sm"
          >
            Unsaved
          </q-chip>

          <!-- Close Button -->
          <q-btn
            v-close-popup
            flat
            round
            icon="close"
            size="md"
            text-color="white"
            @click="emit('close')"
          >
            <q-tooltip>Close</q-tooltip>
          </q-btn>
        </q-btn-group>
      </div>
    </div>
  </q-card-section>
</template>

<script setup>
  defineProps({
    loading: {
      type: Boolean,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
    showImport: {
      type: Boolean,
      default: true,
    },
    quoteContext: {
      type: Object,
      default: null,
    },
  });

  const emit = defineEmits(['refresh', 'export', 'import', 'close']);
</script>

<style scoped>
.schema-header {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
